export const DROPDOWN_AMOUNT_OPTIONS_FIAT = [
    {
        key: 5000,
        name: '50'
    },
    {
        key: 10000,
        name: '100'
    },
    {
        key: 25000,
        name: '250'
    },
    {
        key: 50000,
        name: '500'
    },
    {
        key: 100000,
        name: '1,000'
    },
    {
        key: 250000,
        name: '2,500'
    },
    {
        key: 500000,
        name: '5,000'
    },
];

export const DROPDOWN_AMOUNT_OPTIONS_BTC = [
    {
        key: 0.005,
        name: '0.005'
    },
    {
        key: 0.01,
        name: '0.01'
    },
    {
        key: 0.02,
        name: '0.02'
    },
    {
        key: 0.05,
        name: '0.05'
    },
    {
        key: 0.1,
        name: '0.1'
    },
    {
        key: 0.5,
        name: '0.5'
    },
];

export const WITHDRAWAL_ACTIONS_OPTIONS = [
    {
        key: 'approve',
        name: 'Approve'
    },
    {
        key: 'reject',
        name: 'Reject'
    },
    {
        key: 'delete',
        name: 'Delete'
    }
];


export const DROPDOWN_REJECT_OPTIONS = {
    'aml': 'AML',
    'late bets': 'Late Bets',
    'other': 'Other'
};
